module.exports = __webpack_public_path__ + "img/city-ico-white.0111028c.svg";